/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Offer type for carousel content items.
 * Mirrors the offer type concept from @tivocorp/data-domain-lib.
 */
enum OfferType {
  /** Linear broadcast content airing on a schedule. */
  Live = "Live",
  /** Start-over / catch-up linear content. */
  Socu = "Socu",
  /** Video-on-demand content. */
  Vod = "Vod",
  /** Recorded content from a DVR. */
  Recording = "Recording",
  /** Multiple offers. */
  Any = "Any"
}

export { OfferType };
